import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api/user";

export const studentApi = createApi({
  reducerPath: "studentApi",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    introSeen: builder.mutation({
      query: ({Token}) => ({
        url: "/intro-seen",
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
    }),
  }),
});

export const { useIntroSeenMutation } = studentApi;
